import React, { PureComponent } from "react";
import { branch } from "baobab-react/higher-order";
import Modal from "react-responsive-modal";
import autoBind from "react-autobind";
import FontAwesome from "react-fontawesome";
import Comments from "./Comments";

class PlayerCommentsModal extends PureComponent {
	constructor(props) {
		super(props);
		autoBind(this);

		this.state = { paused: false };
	}

	onClickClose() {
		if (this.props.onClickClose) {
			this.props.onClickClose();
		}
	}

	// Doing at runtime...could potentially do first time loads up in state
	render() {
		let modal =
			<Modal classNames={{
				overlay: "ambifi-web-player",
				modal: "player-comments-modal",
				transitionEnter: "ambifi-web-player-modal-slide-up-enter",
				transitionEnterActive: "ambifi-web-player-modal-slide-up-enter-active",
				transitionExit: "ambifi-web-player-modal-slide-up-exit",
				transitionExitActive: "ambifi-web-player-modal-slide-up-exit-active"
			}}
				open={this.props.isOpen}
				showCloseIcon={false}
				onEntered={this.onModalEntered}
				onClose={() => { }}>
				<div style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%", alignItems: "center", padding: "16px 30px 16px 30px", boxSizing: "border-box" }}>
					<div className="player-comments-modal-title">Comments / Notes</div>
					<div style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", marginBottom: "10px", maxHeight:'100%',overflow:"hidden" }}>
						<Comments listIndex={this.props.listIndex} sectionIndex={this.props.sectionIndex} itemIndex={this.props.itemIndex} />
					</div>
					<div className="player-comments-modal-close-button" onClick={this.onClickClose}><FontAwesome name="chevron-down" /> GO BACK</div>
				</div>
			</Modal>;

		return modal;
	}
}

PlayerCommentsModal.defaultProps = {
};

export default branch({}, PlayerCommentsModal);